import React, { useState } from "react";
import { Button, Card, Form, Input, message, Typography } from "antd";
import { LockOutlined } from "@ant-design/icons";
import api from "../../api";

const { Title, Text } = Typography;

const AgentChangePasswordPage = () => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const onFinish = async (values: {
        current_password: string;
        new_password: string;
        confirm_password: string;
    }) => {
        if (values.new_password !== values.confirm_password) {
            form.setFields([
                {
                    name: "confirm_password",
                    errors: ["New passwords do not match."],
                },
            ]);
            return;
        }

        setLoading(true);

        try {
            await api.post("/users/change_password/", {
                old_password: values.current_password,
                new_password: values.new_password,
            });

            message.success("Password changed successfully.");
            form.resetFields();
        } catch (err: any) {
            const msg =
                err.response?.data?.error ||
                err.response?.data?.detail ||
                "Failed to change password.";

            form.setFields([
                {
                    name: "current_password",
                    errors: [msg],
                },
            ]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div style={{ marginBottom: 16 }}>
                <Title level={3} style={{ marginBottom: 4 }}>
                    Change Password
                </Title>
                <Text type="secondary">
                    Update your password securely.
                </Text>
            </div>

            <Card style={{ maxWidth: 520 }}>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    requiredMark={false}
                >
                    <Form.Item
                        name="current_password"
                        label="Current Password"
                        rules={[
                            {
                                required: true,
                                message: "Please enter your current password.",
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            autoComplete="current-password"
                        />
                    </Form.Item>

                    <Form.Item
                        name="new_password"
                        label="New Password"
                        rules={[
                            {
                                required: true,
                                message: "Please enter your new password.",
                            },
                            {
                                min: 8,
                                message: "Password must be at least 8 characters.",
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            autoComplete="new-password"
                        />
                    </Form.Item>

                    <Form.Item
                        name="confirm_password"
                        label="Confirm New Password"
                        rules={[
                            {
                                required: true,
                                message: "Please confirm your new password.",
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            autoComplete="new-password"
                        />
                    </Form.Item>

                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        block
                    >
                        Change Password
                    </Button>
                </Form>
            </Card>
        </div>
    );
};

export default AgentChangePasswordPage;